import { useMessageTemplatesListQuery, useSendReservationEmailMutation } from 'src/api/api.generated'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'

export default function SendMessageTemplateCrud({ tenantId }: { tenantId: string }) {
  const showError = useErrorSnackBar()
  const { data: messageTemplatesData, loading: messageTemplateLoading } = useMessageTemplatesListQuery({
    variables: {
      filter: {
        customOnly: false,
        tenantId: { eq: tenantId },
      },
    },
    onError: showError,
  })

  const [sendMessageTemplate, { loading: sendMessageTemplateLoading }] = useSendReservationEmailMutation({
    onError: showError,
    refetchQueries: ['GetReservationEmails'],
  })

  const messageTemplates = messageTemplatesData?.messageTemplates ?? []

  return {
    messageTemplates,
    loading: sendMessageTemplateLoading || messageTemplateLoading,
    sendMessageTemplate,
  }
}
